import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { EventUsersFeedback } from '@/enitites/event/model/types'
import { useImage } from '@/shared/composables/image'
import IconLike from '@/shared/icons/IconLike.vue'
import IconMinus from '@/shared/icons/IconMinus.vue'
import IconPlus from '@/shared/icons/IconPlus.vue'
import { EVENT_STAR_CONFIG } from '../constants'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventUserFeedback',
  props: {
    feedback: null,
    withLine: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  feedback: EventUsersFeedback
  withLine: boolean
};



const showMore = ref(false)

const RATING_CATEGORIES = [
  { key: 'timeliness', label: 'Timeliness', value: props.feedback.timeliness },
  { key: 'communication', label: 'Communication', value: props.feedback.communication },
  { key: 'venue', label: 'Venue', value: props.feedback.venue },
  { key: 'vibe', label: 'Vibe', value: props.feedback.vibe },
  { key: 'musicSound', label: 'Music / Sound', value: props.feedback.musicSound },
] as const
const { getAvatar } = useImage()

function formatDate(dateString: string | Date) {
  const date = new Date(dateString)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // Месяцы с 0
  const year = date.getFullYear()
  return `${day}.${month}.${year}`
}

return { __sfc: true,props, showMore, RATING_CATEGORIES, getAvatar, formatDate, IconLike, IconMinus, IconPlus, EVENT_STAR_CONFIG }
}

})